<script setup lang="ts">
import { AdvisorProfileListItem } from "@/types/profile"
import Border from "@/components/shared/Border.vue"
import { outboundCapture } from "@/composables/advisor-profile"

const props = defineProps<{
  title: string
  items: AdvisorProfileListItem[]
}>()
</script>

<template>
  <div
    v-if="props.items.length > 0"
    class="bg-white px-5 py-6 2xl:px-6 2xl:py-7 rounded-xy shadow-md border border-neutral-100"
  >
    <h3 class="text-lg leading-5 font-bold mb-2 text-neutral-600">
      {{ props.title }}
    </h3>

    <Border size="short" class="mb-6" />

    <ul class="space-y-1.5">
      <li v-for="(item, index) in props.items" :key="index">
        <div class="inline-flex items-start gap-x-1.5">
          <component :is="item.icon" class="w-5 h-5 shrink-0 text-xy-blue" />
          <span class="text-sm font-medium text-xy-black">
            <template v-if="item.link">
              <a
                :href="item.link"
                class="xy-link"
                target="_blank"
                rel="external"
                @click.prevent="outboundCapture(item.link)"
                >{{ item.value }}</a
              >
            </template>
            <template v-else>
              {{ item.value }}
            </template>
          </span>
        </div>
      </li>
    </ul>

    <div v-if="$slots['default']" class="mt-5">
      <slot />
    </div>
  </div>
</template>
